<template>
  <div>
    <div v-if="!settings || !settings.isPremium" class="dashboard-wrapper dashboard-wrapper--stub"></div>
    <div v-else class="dashboard-wrapper dashboard-wrapper--parent" :class="{'menu-open' : mobileOpen}">
      <Header/>
      <div class="dashboard-header">
        <div class="dashboard-title grid-title-cell-1">Parent <span class="pro-label">Pro</span> <br> {{$lang.messages.dashboard.title}}</div>
        <div class="dashboard-subtitle grid-title-cell-2 desktop-hidden">{{$lang.messages.dashboard.welcome}}</div>
        <button class="btn btn-main -shadow grid-title-cell-3" @click="openLockDevicePopup">{{$lang.messages.start_kids_mode}}</button>
      </div>
      <div class="dashboard-content">
        <DashboardTabs :activeTab="activeTab" @toggletab="changeTab"/>
        <div class="dashboard-profiles">
          <div class="dashboard-message-block">
            <div class="dashboard-message">{{$lang.messages.dashboard.welcome}}</div>
            <img src="../assets/img/dashboard/dashboard-girl.png" alt="dashboard">
          </div>
          <div class="dashboard-profiles-content dashboard-device-list" v-if="activeTab === 'devicesTab'">
            <div class="tablet-hidden flex-v-center flex-between w-100">
              <span class="text-bold text-lg text-uppercase">{{$lang.messages.dashboard.tabs.devices}}</span>
              <button class="btn-add-mobile" @click="addNewDevice">
                {{$lang.messages.dashboard.device.title}}
              </button>
            </div>
            <DashboardDevice v-for="(device, index) in settings.devices" :key="index"
                             :deviceID="index" :device="device" :currentDeviceID="currentDeviceID"
                             @toggle-kids-mode="toggleKidsMode"/>
            <div @click="addNewDevice" class="dashboard-profile add-profile mobile-hidden">
              <div>
                <div class="add-profile-plus">+</div>
                <div class="add-profile-label">{{$lang.messages.dashboard.device.add_device}}</div>
              </div>
            </div>
          </div>
          <div class="dashboard-profiles-content" v-if="activeTab === 'profilesTab'">
            <div class="tablet-hidden flex-v-center flex-between">
              <span class="text-bold text-lg text-uppercase">{{$lang.messages.dashboard.tabs.kids}}</span>
              <button class="btn-add-mobile" @click="goAddProfile">
                {{$lang.messages.dashboard.profile.title}}
              </button>
            </div>
            <div class="dashboard-profile-list">
              <DashboardProfile v-for="(profile, index) in settings.profiles" :key="index"
                                :index="index" :profile="profile" :activeProfiles="activeProfiles"
                                @toggle-kids-mode="toggleKidsMode"/>
              <div class="dashboard-profile add-profile mobile-hidden" @click="goAddProfile">
                <div>
                  <div class="add-profile-plus">+</div>
                  <div class="add-profile-label">{{$lang.messages.dashboard.profile.add_profile}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Help :videoIsOpen="showTutorialVideo"/>
      <Feedback/>
      <Modal size="sm" v-if="showCreateKidModeModal" @hidemodal="showCreateKidModeModal = false">
        <div slot="header" class="content-block-title mb-0 mt-0 mr-2">{{$lang.messages.dashboard.run_kids_mode_modal_title}}</div>
        <div slot="content">
          <LockDeviceWithProfile
              @startkidsmode="startKidsMode"
              :default-device="deviceToLock || currentDeviceID || false"
          />
        </div>
      </Modal>
    </div>
    <PremiumFeaturesModal
        v-if="showPremiumFeatures"
        :showClose="true"
        v-on:gettrial="showPremium"
        v-on:hidemodal="showPremiumFeatures = false"
        v-on:goback="isAndroid ? $router.push('/popup') : $router.push('/freeDashboard')"/>
    <WelcomeScreens
        alias="dashboardProWelcome"
        v-if="settings.isPremium && showWelcomeScreen && !showPremiumIsPurchased"
        @hidewelcome="showWelcomeScreen = false"/>
    <PremiumPurchasedModal
        v-show="showPremiumIsPurchased"
        v-on:closemodal="showPremiumIsPurchased = false"/>
    <GetPremiumModal
        v-if="showGetPremium"
        :customer="accountData.customer"
        v-on:closepremiummodal="showGetPremium = false"
        v-on:premiumispurchased="showPremiumFeatures = false; showPremiumIsPurchased = true"
        v-on:updatesettings="saveAccountSettings"/>
    <GetPremiumModalAndroid
        v-if="showGetPremiumAndroid"
        v-on:closepremiummodal="showGetPremiumAndroid = false" />
    <Modal v-if="showAddChildPopup" @hidemodal="showAddChildPopup = false" lowheader="true">
      <AddChildPopup
          slot="content"
          v-on:showaddlinkmodal="showAddLinkModal = true"
          v-on:adddeviceshow="showAddDeviceFromAddChild"
          v-on:closeaddchild="showAddChildPopup = false"
      />
    </Modal>
    <AddDevice
        v-if="addDeviceShow"
        v-on:closepopup="addDeviceShow = false; addDeviceScreen = ''"
        :defaultOpenScreen="addDeviceScreen"
    />
  </div>
</template>
<script>
import {reportEvent, getSessionDuration} from '../helpers/utils'
import firebase from 'firebase/app'
import Help from "@/components/Help"
import Feedback from "@/components/Feedback";
import Header from "@/components/Header";
import {mapGetters, mapState} from 'vuex';
import saveSetting from "@/components/mixins/saveSetting";
import AddDevice from "@/components/AddDevice";
import Modal from "@/components/common/Modal";
import PremiumFeaturesModal from "@/components/PremiumFeaturesModal";
import WelcomeScreens from "@/components/WelcomeScreens";
import GetPremiumModalAndroid from "@/components/GetPremiumModalAndroid";
import GetPremiumModal from "@/components/GetPremiumModal";
import PremiumPurchasedModal from "@/components/PremiumPurchasedModal";
import LockDeviceWithProfile from "@/components/LockDeviceWithProfile";
import AddChildPopup from "@/components/AddChildPopup";
import DashboardTabs from "@/components/DashboardTabs";
import DashboardProfile from "@/components/DashboardProfile";
import DashboardDevice from "@/components/DashboardDevice";

export default {
  name: 'Parent',
  mixins: [saveSetting],
  data: function () {
    return {
      slidesDate: [
        {
          img: require('../assets/img/welcome/welcome-dashboard-1.png'),
          label: this.$lang.messages.dashboard.welcome_screen.feature_text_1
        },
        {
          img: require('../assets/img/welcome/welcome-dashboard-2.png'),
          label: this.$lang.messages.dashboard.welcome_screen.feature_text_2
        }, {
          img: require('../assets/img/welcome/welcome-dashboard-3.png'),
          label: this.$lang.messages.dashboard.welcome_screen.feature_text_3
        },
      ],
      currentWelcomeSlideIndex: 0,
      activeTab: 'profilesTab',
      profileOpen: false,
      activeProfileId: null,
      extIsSetUp: !JSON.parse(localStorage.getItem('isRemote')),
      mobileOpen: false,
      showGetPremium: false,
      showGetPremiumAndroid: false,
      showPremiumIsPurchased: true,
      showMessageInLogin: false,
      showPremiumFeatures: this.$store.getters.getUserRole !== 'premium',
      newUserLogged: false,
      accountOpen: false,
      isAndroid: window.Android,
      isMobileView: window.innerWidth <= 768,
      unsubscribeFB: null,
      testPayment: localStorage.getItem('stripeTest'),
      addDeviceShow: false,
      showCreateKidModeModal: false,
      showWelcomeScreen: !localStorage.getItem('dashboardProWelcome'),
      showAddChildPopup: false,
      addDeviceScreen: '',
      deviceToLock: false
    }
  },
  computed: {
    showTutorialVideo: function () {
      return false;
    },
    ...mapGetters({
      activeProfiles: 'activeProfiles',
    }),
    ...mapState({
      settings: state => state.accountData,
      currentDeviceID: state => state.currentDeviceID,
      user: state => state.user,
      accountData: state => state.accountData
    })
  },
  methods: {
    changeTab(tabTitle){
      this.activeTab = tabTitle
    },
    openLockDevicePopup(){
      this.showCreateKidModeModal = true
      this.deviceToLock = false
    },
    showPremium(){
      this.isAndroid ? this.showGetPremiumAndroid = true : this.showGetPremium = true
      reportEvent('premiumDialogOpen', {src: 'Dashboard'})
    },
    showAddDeviceFromAddChild(){
      this.addDeviceScreen = 'mobile'
      this.addDeviceShow = true
    },
    startKidsMode(profileToLock, deviceToLock) {
      this.showCreateKidModeModal = false;
      this.lockDeviceWithProfile(profileToLock, deviceToLock);
    },
    lockDeviceWithProfile(profileId, deviceId) {
      reportEvent('startKidsMode', {
        isRemote: deviceId !== this.currentDeviceID,
      });
      this.saveDeviceSettings(deviceId,
          {
            locked: true,
            currentProfileID: profileId,
          });
    },
    goAddProfile(){
      this.showAddChildPopup = true
    },
    openProfile(index){
      this.$router.push({path: 'profile', query: {id: index}})
    },
    addNewDevice() {
      this.addDeviceShow = true
    },
    goBackAndroid () {
      if (window.Android) {
        window.Android.sendJsMsgToBackApp();
      }
    },
    toggleKidsMode (device, setting) {
      if (setting.locked) {
        this.showCreateKidModeModal = true;
        this.deviceToLock = device;
      } else {
        const profileIDAtUnlockedDevice = this.accountData.devices[device].currentProfileID;
        const profileAtUnlockedDevice = this.accountData.profiles[profileIDAtUnlockedDevice];

        const sessionDuration = profileAtUnlockedDevice ? getSessionDuration(profileAtUnlockedDevice.startSessionTime) : null;
        console.log(device, setting, profileIDAtUnlockedDevice,profileAtUnlockedDevice );

        reportEvent('exitKidsMode', {
          isRemote: device !== this.currentDeviceID,
          sessionDuration
        });
        this.saveDeviceSettings(device, setting)
      }
    },
    signOut () {
      const query = this.$router.currentRoute.query;
      if (window.Android && this.settings.fcmToken) {
        const filteredTokens = this.settings.fcmToken.filter(token => token !== query.token)
        this.savesettings({
          fcmToken: filteredTokens
        })
      }
      firebase.auth().signOut()
      reportEvent('userSignOut')
    },
    closeMobileMenu () {
      this.mobileOpen = false
    },
  },
  components: {
    DashboardDevice,
    DashboardProfile,
    DashboardTabs,
    AddChildPopup,
    LockDeviceWithProfile,
    AddDevice,
    Header,
    Feedback,
    Help,
    Modal,
    PremiumFeaturesModal,
    WelcomeScreens,
    PremiumPurchasedModal,
    GetPremiumModalAndroid,
    GetPremiumModal,
  },
  mounted() {
    const urlQuery = this.$router.currentRoute.query
    this.showPremiumIsPurchased = !!urlQuery.showbuypremium
    this.newUserLogged = !!urlQuery.newuser
    // this.$router.push(this.$route.path)
  },
  watch: {
    settings(newSettings) {
      if (newSettings && newSettings.isPremium && this.showGetPremiumAndroid) {
        this.showGetPremiumAndroid = false;
        this.showPremiumIsPurchased = true;
      }
    }
  }
}
</script>

<style lang="scss">
  @import "../assets/styles/base.module";
</style>
